import React from "react";
import { SelectMediaDevices } from "components/shared/select-media-devices/SelectMediaDevices";
import { toggleLocalTrackControls } from "store/local-tracks/slice";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import { Checkbox } from "components/shared/input/checkbox/Checkbox";
import { RootState } from "store/reducers";
import { toggleMuteAllParticipants } from "store/remote-participants/slice";
import styles from "./Settings.module.css";

interface SettingsProps {}
export const Settings: React.FC<SettingsProps> = () => {
  const dispatch = useDispatch();
  const { muteAll } = useSelector((s: RootState) => s.remoteParticipants);
  
  return (
    <div className={styles["settings-container"]}>
      <div className={styles["dialog"]}>
        <div className="mb-4 pl-4 pr-4">
          <p className="lead text-center mb-0">Settings</p>
        </div>
        <SelectMediaDevices showPreview={false} showMicTest={false} />
        {isMobile && (
          <Checkbox
            label="Mute Device Speaker"
            id="mute-speaker-checkbox"
            checked={muteAll}
            onChange={() => dispatch(toggleMuteAllParticipants())}
            small="All incoming audio will be muted."
          />
        )}
        <button
          type="button"
          className="btn btn-primary btn-block"
          onClick={(e) => {
            e.preventDefault();
            dispatch(toggleLocalTrackControls(false));
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};
